'use strict';


const { bindGA, sendEventGA, normalizePayload } = require('./util/analytics-util');
const { getProductData, hasClass, queryFirst } = require('lilly/domUtil');

const BUTTONS_CATEGORY = 'wishlist buttons';
const SUBMISSIONS_CATEGORY = 'submissions';
const SHARE_ACTION = 'share a wishlist';
const CREATE_ACTION = 'create new list';

/**
 * Analytics for Wishlist
 */
function initEvents() {
    const { body } = document;
    const $body = $(body);

    // Remove from Wishlist
    bindGA(body, (bindElement, srcElement) => {
        const { masterId, originalPrice, productColor, productId, productName, productPrice, productSize } = getProductData(srcElement);

        return {
            event_category: BUTTONS_CATEGORY,
            event_action: 'remove from wishlist',
            event_label: [productName, masterId],
            product_color: [productColor || ''],
            product_id: [masterId || ''],
            product_name: [productName || ''],
            product_original_price: [originalPrice || ''],
            product_price: [productPrice || ''],
            product_size: [productSize || ''],
            product_sku: [productId || '']
        };
    }, {
        bindOptions: {
            targetSelectors: ['.js-remove-from-wishlist']
        }
    });

    // Notify Me
    bindGA(body, (bindElement, srcElement) => {
        const { productName, masterId, productColor, productSize } = getProductData(srcElement);

        return {
            event_category: 'notify me',
            event_action: [productName, masterId],
            event_label: [productColor, productSize]
        };
    }, {
        bindOptions: {
            targetSelectors: ['.wishlist-notify-me-btn']
        }
    });

    // Notify Me - Email Submit
    bindGA(body, (bindElement, srcElement) => {
        const container = srcElement.closest('.js-notify-me-container');

        const productNameEl = queryFirst('.js-notify-product-name', container);
        const masterIdEl = queryFirst('.js-notify-form', container);
        const productColorEl = queryFirst('.wishlist-item-attribute-color .wishlist-detail-value', container);
        const productSizeEl = queryFirst('.wishlist-item-attribute-size .wishlist-detail-value', container);

        const productName = (productNameEl && productNameEl.textContent.trim()) || '';
        const masterId = (masterIdEl && masterIdEl.dataset.masterId) || '';
        const productColor = (productColorEl && productColorEl.textContent.trim()) || '';
        const productSize = (productSizeEl && productSizeEl.textContent.trim()) || '';

        return {
            event_category: 'notify me - email submit',
            event_action: [productName, masterId],
            event_label: [productColor, productSize]
        };
    }, {
        bindOptions: {
            targetSelectors: ['.wishlist-notify-me-submit']
        }
    });

    // Privacy settings
    bindGA(queryFirst('.wishlist-settings', body), (bindElement, srcElement) => {
        return {
            event_category: BUTTONS_CATEGORY,
            event_action: srcElement.dataset.wishlistType
        };
    }, {
        eventType: 'change',
        retriggerEvent: false,
        bindOptions: {
            targetSelectors: ['#wishlist-setting-private', '#wishlist-setting-public']
        }
    });

    // Show More
    bindGA(body, (bindElement, srcElement) => {
        return {
            event_category: BUTTONS_CATEGORY,
            event_action: 'Show More'
        };
    }, {
        bindOptions: {
            targetSelectors: ['.more-wishlist-items']
        }
    });

    // View/change wishlist
    $body.on('wishlist:viewselected', () => {
        sendEventGA(normalizePayload({
            event_category: BUTTONS_CATEGORY,
            event_action: 'view wishlist collection'
        }));
    });

    // Open Edit Modal Dialog
    bindGA(body, (bindElement, srcElement) => {
        return {
            event_category: BUTTONS_CATEGORY,
            event_action: 'edit wishlist collection',
            event_label: 'initiate'
        };
    }, {
        retriggerEvent: false,
        bindOptions: {
            targetSelectors: ['.edit-list-name']
        }
    });

    // Open Share Modal Dialog
    bindGA(body, (bindElement, srcElement) => {
        return {
            event_category: BUTTONS_CATEGORY,
            event_action: SHARE_ACTION,
            event_label: 'initiate'
        };
    }, {
        retriggerEvent: false,
        bindOptions: {
            targetSelectors: ['.share-list']
        }
    });

    // Dialog Actions (Edit & Share)
    bindGA(body, (bindElement, srcElement) => {
        let action = 'edit wishlist';
        let label = '';

        if (hasClass(srcElement, 'update-list-name-btn')) {
            label = 'update';
        } else if (hasClass(srcElement, 'delete-list-btn-popup')) {
            label = 'delete';
        } else if (hasClass(srcElement, 'edit-wishlist-close')) {
            label = 'cancel';
        } else if (hasClass(srcElement, 'copy-share-link-btn')) {
            action = SHARE_ACTION;
            label = 'copy link';
        } else if (hasClass(srcElement, 'share-wishlist-close')) {
            action = SHARE_ACTION;
            label = 'cancel';
        } else {
            return false;
        }

        return {
            event_category: BUTTONS_CATEGORY,
            event_action: action,
            event_label: label
        };
    }, {
        retriggerEvent: false,
        bindOptions: {
            targetSelectors: [
                '.update-list-name-btn',
                '.delete-list-btn-popup',
                '.edit-wishlist-close',
                '.copy-share-link-btn',
                '.share-wishlist-close'
            ]
        }
    });

    // Create Wishlist success/fail
    $body.on('wishlist:createsuccess', () => {
        sendEventGA(normalizePayload({
            event_category: BUTTONS_CATEGORY,
            event_action: CREATE_ACTION,
            event_label: 'add:success'
        }));
    });

    $body.on('wishlist:createfail', () => {
        sendEventGA(normalizePayload({
            event_category: BUTTONS_CATEGORY,
            event_action: CREATE_ACTION,
            event_label: 'add:failure'
        }));
    });

    // Search for wishlist - Results
    $body.on('wishlist:search-results', () => {
        sendEventGA(normalizePayload({
            event_category: BUTTONS_CATEGORY,
            event_action: 'search for wishlist',
            event_label: 'submit:results'
        }));
    });

    // Search for Wishlist - No Results
    $body.on('wishlist:search-noresults', () => {
        sendEventGA(normalizePayload({
            event_category: BUTTONS_CATEGORY,
            event_action: 'search for wishlist',
            event_label: 'submit:no results'
        }));
    });

    // Create Wishlist Cancel
    bindGA(body, (bindElement, srcElement) => {
        return {
            event_category: BUTTONS_CATEGORY,
            event_action: CREATE_ACTION,
            event_label: 'cancel'
        };
    }, {
        retriggerEvent: false,
        bindOptions: {
            targetSelectors: ['.create-wishlist-close']
        }
    });

    // Open Create Wishlist Dialog
    bindGA(body, (bindElement, srcElement) => {
        return {
            event_category: BUTTONS_CATEGORY,
            event_action: CREATE_ACTION,
            event_label: 'initiate'
        };
    }, {
        bindOptions: {
            targetSelectors: ['.create-wishlist-btn-main']
        }
    });

    bindGA(body, (bindElement, srcElement) => {
        return {
            event_category: BUTTONS_CATEGORY,
            event_action: 'set public/private',
            event_label: srcElement.checked ? 'public' : 'private'
        }
    }, {
        bindOptions: {
            targetSelectors: ['#wishlistSetting']
        }
    });
}

initEvents();
